/** Russian for `uz-w2-agent.ts`. */
export const ruAgentW2 = {
  "ruleMessage.edit": "Текст",
  "ruleMessage.title": "Текст сообщения: {name}",
  "ruleMessage.uz": "На узбекском",
  "ruleMessage.ru": "На русском",
  "ruleMessage.hint":
    "{placeholder} заменяется именем клиента. Если клиент писал по-русски, уходит русский текст. Если оставить поле пустым, используется текст Kapitan.",
  "ruleMessage.saved": "Текст сохранён",
  "ruleMessage.failed": "Не удалось сохранить текст",
  "ruleMessage.loadFailed": "Не удалось загрузить стандартный текст.",
  "ruleMessage.retry": "Повторить",
  "ruleMessage.cancel": "Отмена",
  "ruleMessage.save": "Сохранить",

  "jobShare.title": "Дневная доля кредитов",
  "jobShare.hint":
    "Сколько процентов дневного лимита кредитов может потратить эта задача. Если пусто, отдельного лимита нет. Когда доля закончится, диалог перейдёт к оператору.",
  "jobShare.label": "Доля, %",
  "jobShare.save": "Сохранить",
  "jobShare.saved": "Доля сохранена",
  "jobShare.invalid": "Введите целое число от 1 до 100 или оставьте поле пустым.",

  "gateRefusals.title": "Почему AI не сработал",

  "platformSystem.title": "Системные настройки",
  "platformSystem.empty": "Настроек нет.",
  "platformSystem.setting": "Настройка",
  "platformSystem.value": "Значение",
  "platformSystem.save": "Сохранить",
  "platformSystem.saved": "Настройка сохранена",
  "platformSystem.failed": "Не удалось сохранить настройку",
} as const;
